// extracted by mini-css-extract-plugin
export default {"header":"style_header__QwdBa","title":"style_title__vXXAH","deleteButton":"style_deleteButton__DmfS0"};